<template>
  <img :src="src" class="component-cover" @error="error" alt="">
</template>

<script>
export default {
  name: 'Cover',

  props: {
    src: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
    }
  },

  methods: {
    error() {
      this.$el.setAttribute('src', '//res.cdn.changbaimg.com/-/586a5bc089bfade2/cover.png')
    }
  }
}
</script>

<style lang="scss">
</style>
